import { useRef } from 'react';

type HorizontalSwipeOptions = {
  enabled?: boolean;
  threshold?: number;
  onSwipeLeft: () => void;
  onSwipeRight: () => void;
};

export const useHorizontalSwipe = ({
  enabled = true,
  threshold = 45,
  onSwipeLeft,
  onSwipeRight,
}: HorizontalSwipeOptions) => {
  const start = useRef<{ x: number; y: number } | null>(null);

  const onTouchStart = (event: any) => {
    if (!enabled || event.target.closest?.('button, video')) {
      start.current = null;
      return;
    }
    const touch = event.touches[0];
    start.current = { x: touch.clientX, y: touch.clientY };
  };

  const onTouchEnd = (event: any) => {
    if (!start.current || !enabled) return;
    const touch = event.changedTouches[0];
    const horizontalDistance = touch.clientX - start.current.x;
    const verticalDistance = touch.clientY - start.current.y;
    start.current = null;

    if (Math.abs(horizontalDistance) < threshold || Math.abs(horizontalDistance) <= Math.abs(verticalDistance)) return;
    if (horizontalDistance < 0) onSwipeLeft();
    else onSwipeRight();
  };

  const onTouchCancel = () => {
    start.current = null;
  };

  return { onTouchStart, onTouchEnd, onTouchCancel };
};
